import React from 'react';
import { observer } from 'mobx-react';
import { useStores } from '@gtintel/platform-stores';
import NewPartnerReport from './PartnerReportForm/NewPartnerReport';
import UpdatePartnerReport from './PartnerReportForm/UpdatePartnerReport';
import * as S from './styles';
const ReportsTab = ({
  projectId
}) => {
  const {
    adminProjectDetailStore
  } = useStores();
  const {
    projectDetail,
    projectReports
  } = adminProjectDetailStore;
  let content;
  if (projectReports?.results && projectReports.results[0]) {
    content = <UpdatePartnerReport project={projectDetail} projectId={projectId} report={projectReports.results[0]} />;
  } else {
    content = <NewPartnerReport project={projectDetail} projectId={projectId} />;
  }
  return <S.ReportViewCard bordered={false}>{content}</S.ReportViewCard>;
};
export default observer(ReportsTab);